import React from 'react';
import ReactDOM from 'react-dom/client'; // `react-dom/client` をインポート
import App from './App';
import './styles/base.css';  // 全体のスタイル
import reportWebVitals from './reportWebVitals'; // reportWebVitals をインポート

// React 18 以降は createRoot を使用
const root = ReactDOM.createRoot(document.getElementById('root')); // createRoot を使う
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web Vitals の測定結果をログとして表示
reportWebVitals(console.log); // パフォーマンスメトリックをコンソールに表示
